/* A3 Styles: "Order Now" button on product cards.
   Card button -> pop-up (size, size guide, Add to Cart, COD) ->
   Add to Cart adds the size to the cart; COD opens the product page with the size selected and
   ?easysell=1, which makes EasySell open its own COD form once it has loaded the product. */
(function () {
  var css =
    '.a3cod-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:16px}' +
    '.a3cod-overlay[hidden]{display:none}' +
    '.a3cod-box{background:#fff;color:#111;width:100%;max-width:440px;max-height:88vh;overflow:auto;border-radius:14px;padding:20px 18px 18px;position:relative;font-family:inherit;box-shadow:0 10px 40px rgba(0,0,0,.25)}' +
    '.a3cod-close{position:absolute;top:6px;right:8px;background:none;border:0;font-size:30px;line-height:1;cursor:pointer;color:#555;padding:4px 8px}' +
    '.a3cod-title{font-weight:700;font-size:16px;margin:0 32px 2px 0}' +
    '.a3cod-price{font-size:15px;font-weight:600;margin:0 0 12px;color:#333}' +
    '.a3cod-sub{font-size:15px;margin:0 0 10px}' +
    '.a3cod-sizes{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px}' +
    '.a3cod-size{min-width:54px;padding:10px 12px;border:1px solid #bbb;border-radius:8px;background:#fff;font-size:15px;font-weight:600;cursor:pointer;color:#111}' +
    '.a3cod-size:hover{border-color:#2761E7}' +
    '.a3cod-size.is-selected{background:#111;border-color:#111;color:#fff}' +
    '.a3cod-size[disabled]{opacity:.4;text-decoration:line-through;cursor:not-allowed}' +
    '.a3cod-guide-link{background:none;border:0;padding:0;color:#2761E7;font-weight:700;text-decoration:underline;cursor:pointer;font-size:14px}' +
    '.a3cod-guide{margin-top:10px;border-top:1px solid #eee;padding-top:10px;overflow-x:auto}' +
    '.a3cod-guide img{max-width:100%;height:auto}' +
    '.a3cod-guide table{width:100%;border-collapse:collapse;font-size:13px}' +
    '.a3cod-guide td,.a3cod-guide th{border:1px solid #ddd;padding:4px;text-align:center}' +
    '.a3cod-msg{min-height:20px;margin:12px 0 6px;font-size:14px;font-weight:600}' +
    '.a3cod-msg.is-error{color:#d12a2a}.a3cod-msg.is-ok{color:#1a7f37}' +
    '.a3cod-msg a{color:#2761E7;text-decoration:underline;margin-left:6px}' +
    '.a3cod-actions{display:flex;flex-direction:column;gap:10px}' +
    '.a3cod-cart,.a3cod-cod{width:100%;padding:13px 12px;border-radius:8px;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit}' +
    '.a3cod-cart{background:#6ba331;color:#fff;border:1.5px solid #6ba331}' +
    '.a3cod-cod{background:#2761E7;color:#fff;border:1.5px solid #2761E7}' +
    '.a3cod-cart[disabled],.a3cod-cod[disabled]{opacity:.6;cursor:wait}' +
    'button.a3-cod-btn{font:inherit;font-weight:600;cursor:pointer}';

  var overlay, titleEl, priceEl, sizesEl, guideLink, guideBox, msgEl, cartBtn, codBtn, current, selected;
  var guideCache = {};

  function build() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    overlay = document.createElement('div');
    overlay.className = 'a3cod-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="a3cod-box" role="dialog" aria-modal="true" aria-label="সাইজ সিলেক্ট করুন">' +
      '<button type="button" class="a3cod-close" aria-label="Close">&times;</button>' +
      '<p class="a3cod-title"></p>' +
      '<p class="a3cod-price"></p>' +
      '<p class="a3cod-sub">আপনার সাইজ সিলেক্ট করুন</p>' +
      '<div class="a3cod-sizes"></div>' +
      '<button type="button" class="a3cod-guide-link">সাইজ গাইড দেখুন</button>' +
      '<div class="a3cod-guide" hidden></div>' +
      '<div class="a3cod-msg" aria-live="polite"></div>' +
      '<div class="a3cod-actions">' +
      '<button type="button" class="a3cod-cart">Add to Cart</button>' +
      '<button type="button" class="a3cod-cod">ক্যাশ অন ডেলিভারিতে অর্ডার করুন</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    titleEl = overlay.querySelector('.a3cod-title');
    priceEl = overlay.querySelector('.a3cod-price');
    sizesEl = overlay.querySelector('.a3cod-sizes');
    guideLink = overlay.querySelector('.a3cod-guide-link');
    guideBox = overlay.querySelector('.a3cod-guide');
    msgEl = overlay.querySelector('.a3cod-msg');
    cartBtn = overlay.querySelector('.a3cod-cart');
    codBtn = overlay.querySelector('.a3cod-cod');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.a3cod-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
    guideLink.addEventListener('click', showGuide);
    sizesEl.addEventListener('click', function (e) {
      var b = e.target.closest('.a3cod-size');
      if (!b || b.disabled) return;
      select(b);
    });
    cartBtn.addEventListener('click', addToCart);
    codBtn.addEventListener('click', function () {
      if (!needSize()) return;
      codBtn.disabled = true;
      location.href = current.url + (current.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + selected + '&easysell=1';
    });
  }

  function select(b) {
    sizesEl.querySelectorAll('.a3cod-size').forEach(function (x) { x.classList.remove('is-selected'); });
    b.classList.add('is-selected');
    selected = b.dataset.id;
    message('');
  }

  function message(text, type, html) {
    msgEl.className = 'a3cod-msg' + (type ? ' is-' + type : '');
    msgEl.textContent = text;
    if (html) msgEl.insertAdjacentHTML('beforeend', html);
  }

  function needSize() {
    if (selected) return true;
    message('আগে আপনার সাইজ সিলেক্ট করুন', 'error');
    return false;
  }

  function addToCart() {
    if (!needSize()) return;
    cartBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(selected), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        // Let the theme update the cart icon count and cart drawer
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'a3cod', data: { source: 'a3cod', itemCount: cart.item_count, variantId: selected } };
        document.dispatchEvent(ev);
        message('✓ কার্টে যোগ হয়েছে', 'ok', '<a href="/cart">কার্ট দেখুন</a>');
        // The theme opens its cart drawer; get out of its way
        if (document.querySelector('cart-drawer-component, cart-drawer')) setTimeout(close, 250);
      })
      .catch(function (err) {
        message((err && err.description) || 'দুঃখিত, কার্টে যোগ করা যায়নি। আবার চেষ্টা করুন।', 'error');
      })
      .then(function () { cartBtn.disabled = false; });
  }

  function open(btn) {
    if (!overlay) build();
    var variants = [];
    try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch (err) { variants = []; }
    current = { url: btn.dataset.url, chart: btn.dataset.chart || '' };
    selected = null;

    titleEl.textContent = btn.dataset.title || '';
    priceEl.textContent = btn.dataset.price || '';
    sizesEl.innerHTML = '';
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'a3cod-size';
      b.dataset.id = v.id;
      b.textContent = v.t === 'Default Title' ? 'One Size' : v.t;
      if (!v.a) { b.disabled = true; b.title = 'স্টকে নেই'; }
      sizesEl.appendChild(b);
    });
    // Only one size in stock: pick it for the customer
    var enabled = sizesEl.querySelectorAll('.a3cod-size:not([disabled])');
    if (enabled.length === 1) select(enabled[0]);

    guideLink.hidden = !current.chart;
    guideBox.hidden = true;
    guideBox.innerHTML = '';
    message('');
    cartBtn.disabled = false;
    codBtn.disabled = false;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function showGuide() {
    if (!current || !current.chart) return;
    if (!guideBox.hidden) { guideBox.hidden = true; return; }
    guideBox.hidden = false;
    if (guideCache[current.chart]) { guideBox.innerHTML = guideCache[current.chart]; return; }
    guideBox.textContent = '...';
    var chart = current.chart;
    fetch(chart)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('main .rte') || doc.querySelector('main');
        var out = node ? node.innerHTML : '';
        guideCache[chart] = out;
        if (current && current.chart === chart) guideBox.innerHTML = out;
      })
      .catch(function () { guideBox.textContent = ''; });
  }

  // The product card opens the product page on pointer/click; stop that for our button
  ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (type) {
    window.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('.a3-cod-btn')) e.stopPropagation();
    }, true);
  });
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.a3-cod-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(btn);
  }, true);
})();
